import {createContext} from 'react';

export interface State {
  count: number;
}

export  type Action = { type: 'SET_COUNT'; payload: number };

export function reducer(state: State, action: Action): State {
  switch (action.type) {
    case 'SET_COUNT':
      return { ...state, count: action.payload }; 
    default:
      return state;
  }
}

export const TaskContext = createContext<{
  state: State;
  dispatch: React.Dispatch<Action>;
  refresh: () => void; 
} | undefined>(undefined);
